import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LegalPage } from '@/components/generals/legal-page'

const sections = [
    {
        id: 'tickets',
        heading: 'Tickets and admission',
        paragraphs: [
            'A pass admits one person for the days covered by that pass. Passes are checked at the door against the name on the booking, so bring something with your name on it.',
            'Early Bird pricing ends on the date shown in the tickets section, after which the Standard rate applies. Workshop passes are capped at sixty because that is how many people fit in the room, and they are not reissued once sold out.'
        ]
    },
    {
        id: 'transfers',
        heading: 'Transfers and refunds',
        paragraphs: [
            'Passes can be transferred to another person up to 48 hours before the opening keynote. Email us from the address used at booking with the new name and we will reissue it at no cost.',
            'Refunds are available up to 30 days before the event. Inside 30 days we cannot refund, but a transfer is always an option.'
        ]
    },
    {
        id: 'programme',
        heading: 'Programme changes',
        paragraphs: [
            'The schedule published on this site is our current plan. Speakers occasionally cannot travel, and sessions are sometimes moved between halls or times. We will replace like with like wherever we can, and a change to the programme is not grounds for a refund.'
        ]
    },
    {
        id: 'conduct',
        heading: 'Code of conduct',
        paragraphs: [
            'Metric is a professional event, and everyone attending is expected to behave accordingly. Harassment of any kind ends your attendance, without a refund.',
            'If something happens, find a member of the organising team. Every one of them can act on it immediately.'
        ]
    },
    {
        id: 'recording',
        heading: 'Recording and photography',
        paragraphs: [
            'Talks, panels, and keynotes are filmed and photographed. Attending means you accept that you may appear in that material, incidentally, in the audience.',
            'Workshops are never recorded, because people bring real company numbers into the room. Attendees may not film or livestream any session themselves.'
        ]
    },
    {
        id: 'liability',
        heading: 'Liability',
        paragraphs: [
            'Metric is not responsible for travel or accommodation costs if the event is cancelled or postponed. In that case we will refund the pass in full, which is the limit of our liability.',
            'Book flexible fares and refundable rooms where you can.'
        ]
    }
]

const Terms: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Terms'
                description='The terms that apply to Metric Berlin 2026 passes, transfers, refunds, and attendance.'
            />

            <LegalPage
                tag='Legal'
                title='Terms'
                updated='1 February 2026'
                intro='These terms cover buying a pass, attending Metric, and what happens if plans change on either side.'
                sections={sections}
            />
        </Layout>
    )
}

export default Terms
